export default "__VITE_ASSET__DSu_B9Aa__"